import React, { useState } from 'react'
import { Link, useForm, usePage } from '@inertiajs/inertia-react'
import { Inertia } from '@inertiajs/inertia'
import AlertDismissible from '../../../Shared/Components/AlertDismissible'
import Breadcrumbs from '../../../Shared/Components/Breadcrumbs'
import Layout from '../../../Shared/Layout/LayoutAdmin'
import Row from 'react-bootstrap/Row'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'

const ButtonsIndex = ({ buttons = [] }) => {
    const { flash } = usePage().props
    const [deleteTarget, setDeleteTarget] = useState(null)
    const [deleting, setDeleting] = useState(false)

    const form = useForm({
        title: '',
        order: buttons.length + 1,
    })

    const submit = (e) => {
        e.preventDefault()
        form.post(route('sia.manage.sections.store'), {
            preserveScroll: true,
            onSuccess: () => form.setData('title', ''),
        })
    }

    const confirmDelete = () => {
        if (!deleteTarget) return
        setDeleting(true)
        Inertia.delete(route('sia.manage.sections.destroy', deleteTarget.slug), {
            preserveScroll: true,
            onFinish: () => {
                setDeleting(false)
                setDeleteTarget(null)
            },
        })
    }

    return (
        <Row>
            {flash.success && <AlertDismissible message={flash.success} type="success" />}
            {flash.error && <AlertDismissible message={flash.error} type="danger" />}
            <span className="pb-7 pt-7">
                <Breadcrumbs currentPath="/admin/sia/manage" />
            </span>

            <div className="card card-flush">
                <div className="card-header pt-7">
                    <h3 className="card-title">
                        <span className="card-label fw-bold text-gray-800">Botones de Capacitación</span>
                    </h3>
                </div>
                <div className="card-body pt-6">
                    <Form onSubmit={submit} className="d-flex flex-wrap align-items-end gap-3 mb-8">
                        <div style={{ minWidth: 240, flex: '1 1 280px' }}>
                            <label className="form-label fs-7 fw-bold text-gray-600 mb-2">Nuevo botón</label>
                            <Form.Control
                                value={form.data.title}
                                onChange={(e) => form.setData('title', e.target.value)}
                                placeholder="Nombre del menú"
                                required
                            />
                            {form.errors.title && <div className="text-danger small">{form.errors.title}</div>}
                        </div>
                        <div style={{ width: 110 }}>
                            <label className="form-label fs-7 fw-bold text-gray-600 mb-2">Orden</label>
                            <Form.Control
                                type="number"
                                value={form.data.order}
                                onChange={(e) => form.setData('order', parseInt(e.target.value, 10) || 0)}
                                required
                            />
                        </div>
                        <Button type="submit" size="sm" variant="primary" disabled={form.processing}>
                            Agregar botón
                        </Button>
                    </Form>

                    <div className="table-responsive">
                        <table className="table table-row-dashed align-middle gs-0 gy-3 my-0">
                            <thead>
                                <tr className="fs-7 fw-bold text-gray-400 border-bottom-0">
                                    <th className="p-0 pb-3 text-start">Botón</th>
                                    <th className="p-0 pb-3 text-start">Orden</th>
                                    <th className="p-0 pb-3 text-start">Submenús</th>
                                    <th className="p-0 pb-3 text-end">Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {buttons.length === 0 && (
                                    <tr>
                                        <td colSpan={4} className="text-muted py-4">
                                            No hay botones. Crea el primero arriba.
                                        </td>
                                    </tr>
                                )}
                                {buttons.map((button) => {
                                    const empty = (button.children_count || 0) === 0 && (button.items_count || 0) === 0
                                    return (
                                        <tr key={button.id}>
                                            <td className="fw-semibold text-gray-800">{button.title}</td>
                                            <td>{button.order}</td>
                                            <td>{button.children_count || 0}</td>
                                            <td>
                                                <div className="d-flex justify-content-end flex-wrap gap-3">
                                                    <Link
                                                        href={route('sia.manage.section.items', button.slug)}
                                                        className="btn btn-sm btn-primary"
                                                    >
                                                        Entrar
                                                    </Link>
                                                    <Link
                                                        href={route('sia.manage.sections.edit', button.slug)}
                                                        className="btn btn-sm btn-light-primary"
                                                    >
                                                        Editar
                                                    </Link>
                                                    {empty && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-light-danger"
                                                            onClick={() => setDeleteTarget(button)}
                                                        >
                                                            Eliminar
                                                        </button>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <Modal show={deleteTarget !== null} onHide={() => !deleting && setDeleteTarget(null)} centered>
                <Modal.Header closeButton={!deleting}>
                    <Modal.Title>Eliminar botón</Modal.Title>
                </Modal.Header>
                <Modal.Body>¿Eliminar el botón «{deleteTarget?.title}»? Solo se puede si no tiene submenús ni archivos.</Modal.Body>
                <Modal.Footer>
                    <Button variant="light" disabled={deleting} onClick={() => setDeleteTarget(null)}>
                        Cancelar
                    </Button>
                    <Button variant="danger" disabled={deleting} onClick={confirmDelete}>
                        {deleting ? 'Eliminando…' : 'Eliminar'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </Row>
    )
}

ButtonsIndex.layout = (page) => <Layout title="SIA · Administrar botones">{page}</Layout>

export default ButtonsIndex
